<template>
    <div>
    <!-- Modal -->
    <div class="modal fade" id="editarGuiaModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-total modal-dialog-scrollable" role="document">
            <div class="modal-content modal-content-total">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        <span v-if="guia">
                            <span class="badge mr-2" :class="'badge-' + guia.status_color"
                                data-toggle="tooltip" data-placement="top" :title="guia.status_guia">
                                {{ guia.ch_status }}
                            </span>
                            <span v-if="!guia.plano.operadora.fl_sus">Guia</span>
                            <span class="ml-1">{{ guia.nome }}</span>
                            <span class="text-primary mx-2">{{ guia.guia_formatada }}</span>
                            <span class="badge badge-secondary mr-2">{{ guia.status }}</span>
                            <a v-if="guia.guia_fatura" href="#" class="card-link" @click.prevent="$util.abrirFatura(guia.guia_fatura.id_fatura)">
                                Fatura: {{ guia.guia_fatura.id_fatura }}
                            </a>

                            <span class="badge badge-secondary mx-2" v-if="guia.usuario">
                                <i class="fa fa-user-plus mr-2" aria-hidden="true"></i>
                                {{ guia.usuario.st_login }}
                            </span>

                            <span class="ml-3 text-muted" v-if="guia.atendimento.marcacao && guia.atendimento.marcacao.unidade_operacao">
                                {{ guia.atendimento.marcacao.unidade_operacao.search }}
                            </span>

                            <span class="ml-3 small">
                                <a href="#" @click.prevent="abrirAtendimento(guia.id_atendimento)" class="card-link">
                                    #{{ guia.id_atendimento }}
                                </a>
                            </span>
                        </span>
                        <span v-else>
                            Guia...
                        </span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <template v-if="!guia">
                        <az-empty-state msg="Guia não identificada" />
                    </template>

                    <template v-if="guia">

                        <div class="progress mb-2">
                            <div class="indeterminate" v-if="$store.state.loading"></div>
                            <div class="determinate" v-else></div>
                        </div>

                        <!-- Pendências da Guia -->
                        <div v-if="guia.guia_motivo_glosa_pendentes && guia.guia_motivo_glosa_pendentes.length">
                            <az-sub-title title="Pendências da Guia"></az-sub-title>
                            <ul class="list-group mb-2">
                                <li class="list-group-item list-group-item-warning"
                                    v-for="(pend, ipd) in guia.guia_motivo_glosa_pendentes" :key="ipd">
                                    <a href="#" class="card-link text-secondary mr-1" data-toggle="tooltip" data-placement="top" title="Marcar como Resolvida."
                                        @click.prevent="solucionarPendencia (pend)" v-if="pend.fl_ativo">
                                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                                    </a>
                                    <span class="text-success mr-1" data-toggle="tooltip" data-placement="top" title="Resolvida." v-else>
                                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                                    </span>

                                    <a href="#" class="card-link text-secondary mr-3 ml-2" data-toggle="tooltip" data-placement="top" title="Observação."
                                        @click.prevent="editar_obs (pend)">
                                        <i class="fa fa-comment" aria-hidden="true"></i>
                                    </a>
                                    
                                    {{ pend.motivo_glosa.search }}

                                    <span v-if="pend.st_obs_sol"> / {{ pend.st_obs_sol }}</span>

                                    <az-input 
                                        class="mb-3 ml-5"
                                        sizing="sm"
                                        v-if="pend.edit_obs !== null && pend.edit_obs !== undefined"
                                        v-model="pend.edit_obs">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-success" type="button" id="button-addon2" @click="salvar_obs_pend(pend)">
                                                    <i class="fa fa-check" aria-hidden="true"></i>
                                                </button>
                                                <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="editar_obs (pend)">
                                                    <i class="fa fa-times" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </li>
                            </ul>
                        </div>

                        <!-- Autorização -->
                        <ver-autorizacao v-if="guia.atendimento && guia.atendimento.marcacao" :autorizacao="guia.atendimento.marcacao.autorizacao" />

                        <!-- Campos da Guia -->
                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Número da Guia"
                                    sizing="sm"
                                    required
                                    :validate="validate"
                                    :edicao="guia.plano.operadora.guia_operadora && guia.plano.operadora.guia_operadora.fl_editar_guia_prestador"
                                    v-model="guia.st_numero_interno">
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    label="Data do Atendimento"
                                    type="date"
                                    :edicao="guia.pode_alterar_data"
                                    sizing="sm"
                                    v-model="guia.data_guia" >
                                </az-input>
                                <span class="badge badge-warning mb-2" v-if="guia.atendimento.dt_inicio.substr(0,10) != guia.data_guia">
                                    Atendimento: {{ $util.getFormatDate(guia.atendimento.dt_inicio) }}
                                </span>
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    label="Hora do Atendimento"
                                    :edicao="false"
                                    sizing="sm"
                                    :value="guia.dt_criacao.substr(11,5)" >
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input 
                                    v-if="guia.ch_tipo_guia == 'A'"
                                    label="Tipo de APAC"
                                    sizing="sm"
                                    type="select"
                                    placeholder="Tipo de APAC..."
                                    :optionsList="[
                                        { id: 1, search: 'Inicial' },
                                        { id: 2, search: 'Continuidade' },
                                        { id: 3, search: 'Única' },
                                        { id: 4, search: 'Encerramento' },
                                    ]"
                                    optionsData="id"
                                    v-model="guia.in_tipo_apac" />

                                <az-input
                                    v-else
                                    label="Tipo de Atendimento"
                                    type="select"
                                    optionsMode="aql"
                                    service="tipo_atendimentos.index"
                                    optionsData="id_tipo_atendimento"
                                    optionsDisplay="search"
                                    :optionsSync="false"
                                    sizing="sm"
                                    v-model="guia.atendimento.id_tipo_atendimento">
                                    <template v-slot:buttonposb>
                                        <select v-if="guia.atendimento.id_tipo_atendimento == 4" class="form-control" v-model="guia.in_tipo_consulta">
                                            <option value="1">1 - Primeira Consulta</option>
                                            <option value="2">2 - Retorno</option>
                                            <option value="3">3 - Pré-Natal</option>
                                            <option value="4">4 - Encaminhamento</option>
                                        </select>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="form-row" v-if="guia.ch_tipo_guia == 'A' && guia.atendimento.js_info">
                            <div class="col col-12 col-md-6">
                                <az-input   
                                    sizing="sm"
                                    label="Motivo de Saída"
                                    type="select"
                                    optionsMode="aql"
                                    service="sus.motivo_saidas"
                                    optionsData="id"
                                    optionsDisplay="search"
                                    :validate="validate"
                                    v-model="guia.atendimento.js_info.st_motivo_saida" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input   
                                    sizing="sm" 
                                    label="Data de Saída" 
                                    type="date"
                                    :validate="validate"
                                    v-model="guia.atendimento.js_info.dt_saida" />
                            </div>
                        </div>

                        <div class="form-row" v-if="guia.atendimento.st_cirurgia_tipo_guia">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    :label="guia.atendimento.st_cirurgia_tipo_guia == 'S' ? 'Número da Guia Principal' : 'Número da Guia de Solic de Internação'"
                                    sizing="sm"
                                    :validate="validate"
                                    v-model="guia.atendimento.st_guia_principal">
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    label="Acomodação"
                                    sizing="sm"
                                    type="select"
                                    :optionsList="[{id: 'A', search: 'Apartamento'},{id: 'E', search: 'Enfermaria'}]"
                                    optionsData="id"
                                    :edicao="false"
                                    :validate="validate"
                                    v-model="guia.atendimento.st_cirurgia_acomodacao" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Local"
                                    sizing="sm"
                                    type="select"
                                    optionsMode="aql"
                                    service="centro_cirurgicos.index"
                                    optionsData="id_centro_cirurgico"
                                    optionsDisplay="st_centro_cirurgico"
                                    v-model="guia.atendimento.id_centro_cirurgico"
                                    :edicao="false"
                                    :validate="validate" />
                            </div>
                        </div>

                        <p v-if="guia.contrato_operadora && (
                            ( guia.contrato_operadora.fl_fixar_tipo_atendimento && guia.contrato_operadora.id_tipo_atendimento )
                            || ( guia.contrato_operadora.fl_fixar_solicitante && guia.contrato_operadora.id_medico_sol )
                            || ( guia.contrato_operadora.fl_fixar_executante && guia.contrato_operadora.id_medico_exe )
                        )" class="alert alert-info small">
                            Contrato: {{ guia.contrato_operadora.st_descricao_arquivo_contrato }}
                            <ul class="mb-0">
                                <li v-if="( guia.contrato_operadora.fl_fixar_tipo_atendimento && guia.contrato_operadora.id_tipo_atendimento )">
                                    Fixado Tipo de Atendimento: {{ guia.contrato_operadora.tipo_atendimento.st_tipo_atendimento }}
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    {{ guia.contrato_operadora.tipo_atendimento.in_codigo }}
                                </li>
                                <li v-if="( guia.contrato_operadora.fl_fixar_solicitante && guia.contrato_operadora.id_medico_sol )">
                                    Fixado Profissional Solicitante: {{ guia.contrato_operadora.medico_sol.st_nome_exibicao }}
                                </li>
                                <li v-if="( guia.contrato_operadora.fl_fixar_executante && guia.contrato_operadora.id_medico_exe )">
                                    Fixado Profissional Executante: {{ guia.contrato_operadora.medico_exe.st_nome_exibicao }}
                                </li>
                                <li v-if="( guia.contrato_operadora.fl_fixar_tipo_consulta && guia.contrato_operadora.in_tipo_consulta )">
                                    Fixado Tipo de Consulta: {{ guia.contrato_operadora.in_tipo_consulta }}
                                </li>
                            </ul>
                        </p>

                        <az-sub-title class="mt-3" :title="guia.plano.operadora.fl_sus ? 'Dados da Autorização' : 'Dados da Operadora'">
                            <a class="card-link" @click.prevent
                                data-toggle="collapse" href="#collapseOperadora" role="button"
                                aria-expanded="false" aria-controls="collapseExample">
                                {{ guia.plano.search }}
                            </a>
                        </az-sub-title>

                        <div class="collapse" id="collapseOperadora">

                            <div class="form-row">
                                <div class="col col-12 col-md-4" v-if="!guia.plano.operadora.fl_sus">
                                    <az-input
                                        v-if="!mudanca_plano"
                                        label="Operadora / Plano"
                                        :edicao="false"
                                        sizing="sm"
                                        v-model="guia.plano.search"
                                        icon="far fa-credit-card fa-fw"
                                        buttonText="far fa-credit-card fa-fw"
                                        buttonColor="outline-primary"
                                        :buttonIcon="true"
                                        @clickButton="$util.abrirOperadora(guia.plano.operadora)">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="!viewonly && guia.pode_editar">
                                                <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="mudanca_plano = true">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>

                                    <az-input
                                        v-else
                                        label="Operadora / Plano"
                                        sizing="sm"
                                        placeholder="Operadora/Plano..."
                                        type="autocomplete"
                                        optionsMode="aql"
                                        optionsName="planos.atendimento"
                                        :optionsParm="{
                                            atendimento: true,
                                            plano_id_unidade_operacao: guia.atendimento.marcacao.id_unidade_operacao,
                                            id_operadora: guia.id_operadora, 
                                        }"
                                        service="planos.index"
                                        :optionsSync="true"
                                        v-model="guia.novo_plano">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="!viewonly">
                                                <button class="btn btn-outline-success" type="button" id="button-addon2" :disabled="!guia.novo_plano" @click="guia.plano = guia.novo_plano; mudanca_plano = false;">
                                                    <i class="fa fa-check" aria-hidden="true"></i>
                                                </button>
                                                <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="mudanca_plano = false">
                                                    <i class="fa fa-times" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2" v-if="!guia.plano.operadora.fl_sus">
                                    <az-input
                                        label="Registro na ANS"
                                        :edicao="false"
                                        sizing="sm"
                                        v-model="guia.plano.operadora.st_registro_ans">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3" v-if="!guia.plano.operadora.fl_sus">
                                    <az-input
                                        label="No. Guia Atribuido pela Operadora"
                                        sizing="sm"
                                        type="text"
                                        v-model="guia.st_numero" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="APAC"
                                        type="apac"
                                        sizing="sm"
                                        :validate="validate"
                                        v-if="( guia.plano.operadora.fl_sus && guia.ch_tipo_guia == 'A' )"
                                        v-model="guia.st_codigo_autorizacao"/>

                                    <az-input
                                        label="Número da AIH"
                                        type="aih"
                                        sizing="sm"
                                        :validate="validate"
                                        v-else-if="( guia.plano.operadora.fl_sus && guia.ch_tipo_guia == 'I' )"
                                        v-model="guia.st_codigo_autorizacao"/>

                                    <az-input
                                        v-else
                                        label="Senha"
                                        sizing="sm"
                                        :validate="validate"
                                        v-model="guia.st_codigo_autorizacao"/>
                                </div>
                                <template v-if="guia.plano.operadora.fl_sus && guia.st_codigo_autorizacao">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Nome do Autorizador"
                                            sizing="sm"
                                            :validate="validate"
                                            v-model="guia.st_sus_nome_autorizador" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="CNS do Autorizador"
                                            type="cns"
                                            sizing="sm"
                                            :validate="validate"
                                            v-model="guia.st_sus_cns_autorizador" />
                                    </div>
                                </template>
                            </div>

                            <div class="form-row" v-if="guia.st_codigo_autorizacao">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Data da Autorização"
                                        sizing="sm"
                                        type="date"
                                        required
                                        :validate="validate"
                                        v-model="guia.dt_autorizacao" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        :label="guia.plano.operadora.fl_sus ? 'Validade' : 'Validade da Senha'"
                                        sizing="sm"
                                        type="date"
                                        required
                                        :validate="validate"
                                        v-model="guia.dt_validade_autorizacao" />

                                </div>
                            </div>

                            <template v-if="!guia.plano.operadora.fl_sus">

                                <div class="form-row" v-if="guia.contrato_operadora">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            v-if="mudanca_contrato"
                                            label="Contrato com a Operadora"
                                            sizing="sm"
                                            placeholder="Selecione o Contrato..."
                                            type="autocomplete"
                                            optionsMode="aql"
                                            service="contrato_operadoras.index"
                                            :optionsParm="{ id_operadora: guia.id_operadora, guias: true }"
                                            optionsName="contratos-edicao-guia"
                                            :optionsSync="true"
                                            v-model="guia.novo_contrato">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-success" type="button" id="button-addon2" :disabled="!guia.novo_contrato" @click="guia.contrato_operadora = guia.novo_contrato; mudanca_contrato = false;">
                                                        <i class="fa fa-check" aria-hidden="true"></i>
                                                    </button>
                                                    <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="mudanca_contrato = false">
                                                        <i class="fa fa-times" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>

                                        <az-input
                                            v-else
                                            sizing="sm"
                                            label="Código na Operadora"
                                            placeholder="CNPJ"
                                            :edicao="false"
                                            v-model="guia.contrato_operadora.st_numero_prestador">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="!viewonly && ( guia.ch_status == 'AF' || guia.ch_status == 'DI' || guia.ch_status == 'PR' || guia.ch_status == 'PE' || guia.ch_status == 'PT' || guia.ch_status == 'EF' )">
                                                    <button class="btn btn-outline-secondary" type="button" @click="recalc_contrato()"
                                                        :disabled="$store.state.loading">
                                                        <i class="fas fa-sync-alt fa-fw"></i>
                                                    </button>

                                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="guia.novo_contrato = null; mudanca_contrato = true">
                                                        <i class="fas fa-edit"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            label="CNES"
                                            :edicao="false"
                                            v-model="guia.contrato_operadora.st_cnes" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            label="Nome do Contratado"
                                            :edicao="false"
                                            v-model="guia.contrato_operadora.st_nome_contratado" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            label="Descrição"
                                            :edicao="false"
                                            v-model="guia.contrato_operadora.st_descricao_arquivo_contrato" />
                                    </div>
                                </div>

                                <div class="form-row" v-else>
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            label="Código na Operadora"
                                            :edicao="false">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend" v-if="!viewonly">
                                                    <button class="btn btn-outline-primary" type="button" @click="recalc_contrato()"
                                                        :disabled="$store.state.loading">
                                                        <i class="fas fa-sync-alt fa-fw"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>

                            </template>

                        </div>

                        <!-- Dados do Paciente -->

                        <az-sub-title class="mt-3" :title="guia.plano.operadora.fl_sus ? 'Dados do Paciente' : 'Dados do Beneficiário'">
                            <a class="card-link" @click.prevent
                                data-toggle="collapse" href="#collapseBeneficiario" role="button"
                                aria-expanded="false" aria-controls="collapseExample">
                                {{ guia.atendimento.paciente.st_nome }}
                            </a>
                        </az-sub-title>
                        <div class="collapse" id="collapseBeneficiario">
                            <div class="form-row">
                                <template v-if="!guia.plano.operadora.fl_sus">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Matrícula"
                                            :edicao="!guia.atendimento.paciente.paciente_unidade.eleg"
                                            sizing="sm"
                                            :validate="validate"
                                            v-model="guia.atendimento.st_numero_carteira">
                                            <template v-slot:buttonposb>
                                                <servico-operadora
                                                    v-if="!viewonly"
                                                    :elegivel="guia.atendimento.paciente.paciente_unidade.eleg"
                                                    :paciente="guia.atendimento.paciente"
                                                    :marcacao="guia.atendimento.marcacao"
                                                    :plano="guia.plano"
                                                    @changeElegebilidade="elegibilidade"
                                                />
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Validade da Matrícula"
                                            :edicao="!guia.atendimento.paciente.paciente_unidade.eleg"
                                            type="date"
                                            sizing="sm"
                                            :validate="validate"
                                            v-model="guia.atendimento.dt_validade_carteira">
                                        </az-input>
                                    </div>
                                </template>
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        :label="guia.plano.operadora.fl_sus ? 'Nome' : 'Nome do Beneficiário'"
                                        :edicao="true"
                                        sizing="sm"
                                        required
                                        :validate="validate"
                                        v-model="guia.atendimento.paciente.st_nome">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                                                    @click="cadastro_paciente(guia.atendimento.paciente)">
                                                    <i class="fas fa-id-badge" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        label="CNS"
                                        type="cns"
                                        sizing="sm"
                                        :edicao="true"
                                        :validate="validate"
                                        v-model="guia.atendimento.st_sus">
                                    </az-input>
                                </div>
                                <template v-if="guia.plano.operadora.fl_sus">
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            label="Data Nascimento"
                                            type="date"
                                            sizing="sm"
                                            :edicao="false"
                                            v-model="guia.atendimento.paciente.cadastro.dt_nascimento" />
                                    </div>
                                    <div class="col col-12 col-md-1">
                                        <az-input
                                            label="Sexo"
                                            sizing="sm"
                                            :edicao="false"
                                            v-model="guia.atendimento.paciente.cadastro.ch_sexo" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            label="Nome da Mãe"
                                            sizing="sm"
                                            :edicao="false"
                                            v-model="guia.atendimento.paciente.cadastro.st_nome_mae" />
                                    </div>
                                </template>
                            </div>
                        </div>

                        <!-- Dados do Solicitante -->
                        <div v-if="guia.nome != 'Consulta' && ( trocaDeSolicitante || guia.medico_solicitante_guia )">
                            <az-sub-title class="mt-3" title="Dados do Solicitante">
                                <a class="card-link" @click.prevent
                                    data-toggle="collapse" href="#collapseSolicitante" role="button"
                                    aria-expanded="false" aria-controls="collapseExample">
                                    {{ guia.medico_solicitante_guia.medico_solicitante ? guia.medico_solicitante_guia.medico_solicitante.st_nome : '?' }}
                                </a>
                            </az-sub-title>
                            <div class="collapse" id="collapseSolicitante">
                                <template v-if="guia.id_medico_faturar && guia.st_tipo_faturamento == 'P'">
                                    <div class="row">
                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                label="Código na Operadora"
                                                sizing="sm"
                                                type="text" />
                                        </div>
                                        <div class="col col-12 col-md-8">
                                            <az-input
                                                label="Nome do Contratado"
                                                sizing="sm"
                                                type="text" />
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="form-row">
                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                label="Código na Operadora"
                                                sizing="sm"
                                                type="text"
                                                v-model="guia.contratado_solicitante.codigo" />
                                        </div>
                                        <div class="col col-12 col-md-8">
                                            <az-input
                                                label="Nome do Contratado"
                                                sizing="sm"
                                                v-model="guia.contratado_solicitante.nome" />
                                        </div>
                                    </div>
                                </template>

                                <medico-solicitante
                                    v-if="!trocaDeSolicitante"
                                    :block_executante="true"
                                    :block_incluir="true"
                                    ref="medico_solic"
                                    v-model="guia.medico_solicitante_guia"
                                    :validate="validate"
                                    :required="false"
                                    :edicao="true" />

                            </div>
                        </div>

                        <!-- Modelo do Solicitante pelo Atendimento Apenas -->
                        <div v-else-if="guia.nome != 'Consulta' && ( trocaDeSolicitante || guia.atendimento.medico_solicitante )">
                            <az-sub-title class="mt-3" title="Dados do Solicitante">
                                <a class="card-link" @click.prevent
                                    data-toggle="collapse" href="#collapseSolicitante" role="button"
                                    aria-expanded="false" aria-controls="collapseExample">
                                    {{ guia.atendimento.medico_solicitante ? guia.atendimento.medico_solicitante.st_nome : '?' }}
                                </a>
                            </az-sub-title>
                            <div class="collapse" id="collapseSolicitante">
                                <template v-if="guia.id_medico_faturar && guia.st_tipo_faturamento == 'P'">
                                    <div class="row">
                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                label="Código na Operadora"
                                                sizing="sm"
                                                type="text" />
                                        </div>
                                        <div class="col col-12 col-md-8">
                                            <az-input
                                                label="Nome do Contratado"
                                                sizing="sm"
                                                type="text" />
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="form-row">
                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                label="Código na Operadora"
                                                sizing="sm"
                                                type="text"
                                                v-model="guia.contratado_solicitante.codigo" />
                                        </div>
                                        <div class="col col-12 col-md-8">
                                            <az-input
                                                label="Nome do Contratado"
                                                sizing="sm"
                                                v-model="guia.contratado_solicitante.nome" />
                                        </div>
                                    </div>
                                </template>

                                <div class="form-row" v-if="trocaDeSolicitante || guia.atendimento.medico_solicitante">

                                    <div class="col col-12" v-if="trocaDeSolicitante">

                                        <az-input
                                            placeholder="Selecione o Solicitante..."
                                            label="Solicitante"
                                            sizing="sm"
                                            type="autocomplete"
                                            optionsMode="aql"
                                            service="medico_solicitantes.index"
                                            optionsDisplay="search"
                                            :optionsSync="true"
                                            :validate="validate"
                                            v-model="guia.atendimento.medico_solicitante"
                                            @onSearch="setNomeMedico" />

                                    </div>

                                    <template v-else>
                                        <div class="col col-12 col-md-4">
                                            <!-- edicao="edicaoSolicitante" -->
                                            <az-input
                                                label="Nome do Profissional Solicitante"
                                                :edicao="false" 
                                                sizing="sm"
                                                :validate="validate"
                                                v-model="guia.atendimento.medico_solicitante.st_nome">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-prepend" v-if="!viewonly">
                                                        <div class="dropdown">
                                                            <button class="btn btn-outline-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <i class="fas fa-pen"></i>
                                                            </button>
                                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                <a class="dropdown-item" href="#" @click.prevent="edicaoSolicitante = true" v-if="!edicaoSolicitante">Editar Dados do Solicitante</a>
                                                                <a class="dropdown-item" href="#" @click.prevent="edicaoSolicitante = false" v-else>Encerrar Edição do Solicitante</a>
                                                                <a class="dropdown-item" href="#" @click.prevent="trocarSolicitante()">Trocar Solicitante</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </az-input
                                            >
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                label="Conselho"
                                                sizing="sm"
                                                type="select"
                                                optionsMode="aql"
                                                service="conselhos.index"
                                                optionsData="id_conselho"
                                                optionsDisplay="st_sigla"
                                                v-model="guia.atendimento.medico_solicitante.id_conselho"
                                                :edicao="edicaoSolicitante"
                                                required
                                                :validate="validate" />
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                label="Número"
                                                :edicao="edicaoSolicitante"
                                                sizing="sm"
                                                :validate="validate"
                                                required
                                                v-model="guia.atendimento.medico_solicitante.st_numero_conselho">
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                label="UF"
                                                sizing="sm"
                                                type="select"
                                                optionsMode="aql"
                                                service="estados.index"
                                                optionsData="id_estado"
                                                optionsDisplay="st_estado"
                                                v-model="guia.atendimento.medico_solicitante.id_estado_conselho"
                                                required
                                                :edicao="edicaoSolicitante"
                                                :validate="validate" />
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                label="CBO / Especialidade"
                                                sizing="sm"
                                                type="autocomplete"
                                                optionsMode="aql"
                                                service="especialidades.index"
                                                optionsDisplay="search"
                                                :optionsSync="false"
                                                edicao2="edicaoSolicitante"
                                                required
                                                v-model="guia.atendimento.medico_solicitante.especialidade"
                                                :validate="validate" />
                                        </div>
                                    </template>
                                </div>

                                <div class="form-row">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            label="Data da Solicitação"
                                            :edicao="true"
                                            type="date"
                                            sizing="sm"
                                            v-model="guia.atendimento.dt_solicitacao">
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-8">
                                        <az-input label="Indicação Clínica"
                                            type="autocomplete"
                                            optionsMode="aql"
                                            service="cids.index"
                                            optionsData="id_cid"
                                            optionsDisplay="search"
                                            v-model="guia.atendimento.id_cid"
                                            :edicao="true"
                                            sizing="sm"
                                            :validate="true" />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <!-- Dados do Executante -->

                        <az-sub-title class="mt-3" title="Dados do Executante">
                            <a class="card-link" @click.prevent
                                data-toggle="collapse" href="#collapseExecutante" role="button"
                                aria-expanded="false" aria-controls="collapseExample">
                                {{ guia.executante.pessoa.st_nome }}
                            </a>
                        </az-sub-title>
                        <div class="collapse" id="collapseExecutante">
                            <div class="row" v-if="guia.st_tipo_faturamento">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        label="Código na Operadora"
                                        sizing="sm"
                                        v-model="guia.st_numero_contrato_faturar">
                                    </az-input>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        label="Nome do Profissional Executante"
                                        :edicao="false"
                                        sizing="sm"
                                        v-model="guia.executante.pessoa.st_nome">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" data-toggle="tooltip" data-placement="top" title="Profissional Alterado."
                                                    v-if="guia.id_medico_faturar">
                                                    <i class="fas fa-exclamation-triangle"></i>
                                                </span>
                                                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="alterar_profissional()" v-if="!viewonly">
                                                    <i class="fas fa-pen"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                    <div v-if="guia.executante.js_classes && guia.executante.js_classes.length">
                                        <span v-for="(classe, cindex) in guia.executante.js_classes" :key="cindex" class="badge badge-success mr-1">
                                            {{ classe }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        label="Conselho"
                                        :edicao="false"
                                        sizing="sm"
                                        v-model="guia.executante.conselho.st_sigla">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        label="Número"
                                        :edicao="false"
                                        sizing="sm"
                                        v-model="guia.executante.in_numero_conselho">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        label="UF"
                                        :edicao="false"
                                        sizing="sm"
                                        v-model="guia.executante.estado_conselho.st_sigla">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        label="CBO / Especialidade"
                                        :edicao="false"
                                        sizing="sm"
                                        v-model="guia.atendimento.marcacao.procedimento.especialidade.search">
                                    </az-input>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        label="CNS"
                                        type="cns"
                                        :edicao="false"
                                        v-model="guia.executante.st_cns" />
                                </div>
                            </div>

                        </div>

                        <!-- Internação -->
                         <template v-if="guia.intern">
                            <az-sub-title class="mt-3" title="Dados da Internação">
                                <a class="card-link" @click.prevent
                                    data-toggle="collapse" href="#collapseInternacao" role="button"
                                    aria-expanded="false" aria-controls="collapseInternacao">
                                    #{{ guia.intern.id_internacao }}
                                </a>
                            </az-sub-title>
                            <div class="collapse" id="collapseInternacao">
                                <div class="alert alert-secondary d-flex justify-content-between py-1 px-2 small mb-2">
                                    <div title="Admissão">
                                        <i class="fas fa-sign-in-alt fa-fw mr-2"></i>
                                        {{ $util.getFormatDate(guia.intern.dt_admissao) }}
                                        {{ guia.intern.st_hora_admissao }}
                                    </div>

                                    <div title="Alta" v-if="guia.intern.dt_alta">
                                        <i class="fas fa-sign-out-alt fa-fw mr-2"></i>
                                        {{ guia.intern.dt_alta ? $util.getFormatDate(guia.intern.dt_alta) : 'Internação Ativa' }}
                                        {{ guia.intern.st_hora_alta }}
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            label="Tipo de Internação"
                                            type="select"
                                            placeholder="Tipo de Internação..."
                                            :optionsList="[
                                                { id: 'C', search: 'Clínica' },
                                                { id: 'R', search: 'Cirúrgica' }, 
                                                { id: 'O', search: 'Obstétrica' }, 
                                                { id: 'P', search: 'Pediátrica' }, 
                                                { id: 'Q', search: 'Psiquiátrica' }, 
                                            ]"
                                            required
                                            :validate="validate"
                                            optionsData="id"
                                            v-model="guia.intern.st_tipo" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input 
                                            sizing="sm" 
                                            type="select" 
                                            label="Regime de Internação"
                                            placeholder="Não informado..."
                                            :optionsList="[
                                                { id: '1', search: 'Hospitalar' }, 
                                                { id: '2', search: 'Hospital-Dia' }, 
                                                { id: '3', search: 'Domiciliar' }, 
                                            ]"
                                            optionsData="id"
                                            required
                                            :validate="validate" 
                                            v-model="guia.intern.ch_regime" />
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input 
                                            sizing="sm"
                                            label="Tipo de Alta"
                                            type="select"
                                            optionsData="id_tipo_alta"
                                            service="tipo_altas.index"
                                            optionsMode="aql"
                                            :edicao="guia.intern.dt_alta ? true : false"
                                            :validate="validate"
                                            v-model="guia.intern.id_tipo_alta" />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            label="Início do Faturamento"
                                            type="datetime-local"
                                            :step="60"
                                            v-model="guia.dt_inicio_fat">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend" v-if="!guia.dt_inicio_fat">
                                                    <button type="button" class="btn btn-outline-primary" @click="preencher_periodo_da_internacao(guia)">
                                                        <i class="fas fa-sync-alt fa-fw"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            label="Fim do Faturamento"
                                            type="datetime-local"
                                            :step="60"
                                            v-model="guia.dt_fim_fat" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            label="Tipo de Faturamento"
                                            type="select"
                                            :optionsList="[
                                                { id: '1', search: '1 - Parcial' },
                                                { id: '2', search: '2 - Final' },
                                                { id: '3', search: '3 - Complementar' },
                                                { id: '4', search: '4 - Total' },
                                            ]"
                                            optionsData="id"
                                            v-model="guia.st_tipo_fat" />
                                    </div>
                                    <div class="col col-12 col-md-4" v-if="guia.atendimento">
                                        <az-input
                                            sizing="sm"
                                            label="Observação"
                                            v-model="guia.atendimento.st_observacao" />
                                    </div>
                                </div>


                                <div class="mt-3" v-if="pode_ver_conta">
                                    <button type="button" class="btn btn-sm btn-outline-primary mr-1" @click="ver_conta(guia.intern)">
                                        Conta
                                    </button>

                                    <button type="button" class="btn btn-sm btn-outline-primary" @click="imprimir_espelho_guia(guia)">
                                        Espelho da Conta
                                    </button>
                                </div>
                            </div>
                        </template>

                        <!-- Centros de Custo -->
                        <template v-if="guia.centros && guia.centros.length">
                            <table class="table table-sm border-0 table-responsive mt-3 mb-0">
                                <tr>
                                    <td class="text-nowrap">
                                        <a href="#" @click.prevent="centro.id_centro_custo == centro_selec ? centro_selec = '' : centro_selec = centro.id_centro_custo" v-for="(centro, icx) in guia.centros" :key="icx">
                                            <span class="badge mr-1" :class="centro.id_centro_custo == centro_selec ? 'badge-success' : 'badge-secondary'">
                                                {{ centro.st_sigla ? centro.st_sigla : centro.st_nome }}
                                            </span>
                                        </a>
                                    </td>
                                </tr>
                            </table>
                        </template>

                        <!-- PROCEDIMENTOS -->
                        <az-sub-title class="mt-3" title="Procedimentos">
                            <a href="#" @click.prevent="ordem_alfa_proc = !ordem_alfa_proc" class="card-link ml-2" title="Ordem Alfa">
                                <i class="fa fa-sort-alpha-asc" aria-hidden="true" v-if="ordem_alfa_proc"></i>
                                <i class="fa fa-sort-numeric-asc" aria-hidden="true" v-else></i>
                            </a>
                        </az-sub-title>
                        <template v-for="(proc, index) in lista_procedimentos">
                            <div class="form-row" :key="index" v-if="true">
                                <div class="col col-12 col-md-1">
                                    <az-input
                                        v-if="!guia.plano.operadora.fl_sus"
                                        :label="index ? '' : 'Tabela'"
                                        sizing="sm"
                                        type="select"
                                        optionsMode="aql"
                                        service="codigo_tabelas.index"
                                        optionsData="id_codigo_tabela"
                                        optionsDisplay="ch_codigo"
                                        v-model="proc.id_codigo_tabela"
                                        :validate="validate" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        icon="fas fa-pen"
                                        sizing="sm"
                                        :label="!index ? 'Código' : ''"
                                        placeholder="Código..."
                                        v-model="proc.st_codigo"
                                        v-if="proc.st_codigo !== null">
                                    </az-input>

                                    <template v-else>
                                        <small class="form-text text-muted text-nowrap text-truncate" v-if="!index">
                                            Código
                                        </small>
                                        <div class="input-group input-group-sm">
                                            <a href="#"
                                                @click.prevent="editarTabela (proc.item_tabela)"
                                                class="form form-control text-primary card-link bg-light">
                                                <span v-if="proc.item_tabela">
                                                    {{ proc.item_tabela ? proc.item_tabela.st_codigo : '' }}
                                                </span>
                                                <span v-else-if="guia.plano.operadora.fl_sus">
                                                    {{ proc.atendimento_procedimento.procedimento.st_codigo_sus }}
                                                </span>
                                                <span v-else></span>
                                            </a>
                                        </div>
                                    </template>
                                </div>
                                <div class="col col-12 col-md-4">
                                    <small class="form-text text-muted text-nowrap text-truncate" v-if="!index">
                                        Descrição
                                    </small>
                                    <div class="input-group input-group-sm">
                                        <a href="#" @click.prevent="editarTabela (proc.item_tabela)"
                                            class="form form-control text-primary card-link text-nowrap text-truncate bg-light">
                                            <span v-if="guia.plano.operadora.fl_sus">
                                                {{ proc.atendimento_procedimento.procedimento.st_procedimento }}
                                            </span>
                                            <span v-else>
                                                {{ proc.item_tabela ? proc.item_tabela.st_nome : '' }}
                                            </span>
                                        </a>

                                        <div class="input-group-append" v-if="proc.atendimento_procedimento && proc.atendimento_procedimento.js_solics && proc.atendimento_procedimento.js_solics.coop && !proc.id_atendimento_procedimento_equipe">
                                            <span class="input-group-text" data-toggle="tooltip" data-placement="top" title="Cooperado">
                                                <i class="fa-solid fa-c"></i>
                                            </span>
                                        </div>

                                        <div class="input-group-append" v-else-if="proc.atendimento_procedimento_equipe && proc.atendimento_procedimento_equipe.js_info && proc.atendimento_procedimento_equipe.js_info.coop">
                                            <span class="input-group-text" data-toggle="tooltip" data-placement="top" title="Cooperado">
                                                <i class="fa-solid fa-c"></i>
                                            </span>
                                        </div>

                                        <div class="input-group-append" v-if="proc.atendimento_procedimento && proc.atendimento_procedimento.laudo && proc.atendimento_procedimento.laudo.status_laudo && proc.atendimento_procedimento.laudo.status_laudo.fl_nao_coletar">
                                            <span class="input-group-text" data-toggle="tooltip" data-placement="top" title="Pendente / Não Coletar">
                                                <i class="fa fa-ban" aria-hidden="true"></i>
                                            </span>
                                        </div>

                                        <div class="input-group-append" v-if="!proc.id_atendimento_procedimento_equipe && proc.atendimento_procedimento.cid" title="CID do Procedimento">
                                            <span class="input-group-text small">
                                                {{ proc.atendimento_procedimento.cid.st_codigo }}
                                            </span>
                                        </div>
                                            
                                        <div class="input-group-append" v-if="proc.atendimento_procedimento.dt_execucao 
                                            && ( ( proc.item_tabela && proc.item_tabela.fl_info_data ) || proc.atendimento_procedimento.procedimento.fl_info_data )" 
                                            title="Data de Execução">
                                            <span class="input-group-text small">
                                                {{ $util.getFormatDate(proc.atendimento_procedimento.dt_execucao, 'DD/MM') }}
                                            </span>
                                        </div>
                                        <div class="input-group-append" v-if="guia.id_atendimento != proc.atendimento_procedimento.id_atendimento" title="Outro Atendimento">
                                            <span class="input-group-text small">
                                                <small>#{{ proc.atendimento_procedimento.id_atendimento }}</small>
                                                <small class="ml-1" v-if="proc.atendimento_procedimento.atendimento && proc.atendimento_procedimento.atendimento.dt_inicio && proc.atendimento_procedimento.atendimento.dt_inicio.slice(0,10) != guia.atendimento.dt_inicio.slice(0,10)">
                                                    | {{ $util.getFormatDate(proc.atendimento_procedimento.atendimento.dt_inicio, 'DD/MM') }}
                                                </small>
                                            </span>
                                        </div>
                                        <div class="input-group-append" v-if="!viewonly && guia.pode_editar">
                                            <span class="input-group-text" data-toggle="tooltip" data-placement="top" title="Grau de Participação"
                                                v-if="proc.grau_participacao">
                                                {{ proc.grau_participacao.st_codigo_tiss }}
                                            </span>

                                            <refresh-preco
                                                :proc="proc"
                                                :id_guia="guia.id_guia"
                                                @refresh="refresh (true, guia.id_guia)" />

                                            <button class="btn btn-outline-secondary" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i class="fas fa-ellipsis-v"></i>
                                            </button>
                                            <div class="dropdown-menu">
                                                <a class="dropdown-item" href="#" @click.prevent="editar_codigo_item(proc)">Editar Código do Procedimento</a>
                                                <a class="dropdown-item" href="#" @click.prevent="alterar_procedimento(proc)">Alterar Procedimento</a>
                                                <a class="dropdown-item" href="#" @click.prevent="remover_procedimento(proc)">Remover Procedimento</a>
                                                <a class="dropdown-item" href="#" @click.prevent="alterar_grau_partic(proc)" v-if="!guia.plano.operadora.fl_sus">Alterar Grau de Participação</a>
                                                <a class="dropdown-item" href="#" @click.prevent="ver_empacotados(proc)" 
                                                    v-if="proc.atendimento_procedimento 
                                                        && proc.atendimento_procedimento.empacotados
                                                        && proc.atendimento_procedimento.empacotados.length">Visualizar Procedimentos Empacotados
                                                </a>
                                                <a class="dropdown-item" href="#" @click.prevent="alterar_data_execucao(proc)" 
                                                    v-if="proc.atendimento_procedimento.procedimento.fl_info_data || ( proc.item_tabela && proc.item_tabela.fl_info_data )">
                                                    Alterar Data de Execução
                                                </a>
                                                <a class="dropdown-item" href="#" @click.prevent="toggle_cid_proc(proc)">
                                                    CID do Procedimento
                                                </a>
                                                <template v-if="proc.item_tabela">
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item disabled text-muted small" v-if="proc.item_tabela">
                                                        <span v-if="proc.item_tabela.tabela_versao" class="mr-1">
                                                            {{ proc.item_tabela.tabela_versao.search }}
                                                        </span>
                                                        / #{{ proc.item_tabela.id_item_tabela }}
                                                    </a>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="proc.id_medico && proc.id_medico !== guia.atendimento.id_medico && proc.medico" class="small text-muted">
                                        {{ proc.medico.st_nome_exibicao }}
                                    </div>
                                    <template v-if="proc.contrato && proc.contrato.fl_fixar_executante && proc.contrato.medico_exe">
                                        <div class="small text-muted" title="Profissional Fixado pelo Contrato">
                                            <i class="fa-solid fa-thumbtack mr-1"></i>
                                            {{ proc.contrato.medico_exe.st_nome_exibicao }}
                                        </div>
                                    </template>
                                    <div v-if="!proc.dc_valor && proc.st_acatar_justificativa" class="small text-danger" title="Motivo da Remoção">
                                        {{ proc.st_acatar_justificativa }}
                                    </div>
                                    <div v-if="proc.alter_data">
                                        <az-input
                                            :compact="true"
                                            label="Data de Execução"
                                            type="date"
                                            sizing="sm"
                                            v-model="proc.atendimento_procedimento.dt_execucao"
                                            :validate="validate" />
                                    </div>
                                </div>
                                <div class="col col-12 col-md-1">
                                    <az-input
                                        :label="index ? '' : 'Qtd'"
                                        sizing="sm"
                                        type="number"
                                        min="1"
                                        max="9999"
                                        required
                                        :edicao="guia.pode_editar"
                                        v-model="proc.in_quantidade"
                                        :validate="validate" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        v-if="!refreshing"
                                        :label="index ? '' : 'Vl Unitário'"
                                        sizing="sm"
                                        type="money"
                                        :edicao="guia.pode_editar"
                                        v-model="proc.dc_valor"
                                        :validate="validate">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend" v-if="false && proc.item_tabela">
                                                <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                                                    @click="exibir_composicao_valor(proc.item_tabela, guia, proc.atendimento_procedimento.id_reducao)">
                                                    <i class="fas fa-search-dollar"></i>
                                                </button>
                                            </div>
                                        </template>
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="proc.atendimento_procedimento
                                                && proc.id_grau_participacao != 7 
                                                && proc.atendimento_procedimento.dc_percentual_reducao
                                                && proc.atendimento_procedimento.dc_percentual_reducao != 1 ">
                                                <span class="input-group-text" id="basic-addon2">
                                                    {{ Math.round(proc.atendimento_procedimento.dc_percentual_reducao * 100) / 100 }}
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <small class="form-text text-muted text-nowrap text-truncate" v-if="!index">
                                        Valor
                                    </small>
                                    <div class="input-group input-group-sm">
                                        <label class="form form-control bg-light">
                                            {{ $util.formatMoeda(proc.dc_valor * proc.in_quantidade) }}
                                        </label>
                                        <div class="input-group-append" title="Centro de Custo" v-if="proc.atendimento_procedimento && guia.centros && guia.centros.length">
                                            <span class="input-group-text">
                                                <a href="#" @click.prevent="alterar_centro_custo(proc.atendimento_procedimento)" class="card-link">
                                                    <small>{{ proc.atendimento_procedimento.centro_selec ? proc.atendimento_procedimento.centro_selec.st_sigla : '?' }}</small>
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <template v-if="proc.info_cid">

                                <div class="form-row" :key="'CID' + index">
                                    <div class="col col-12">
                                        <az-input
                                            placeholder="Informar o CID do procedimento..."
                                            class="ml-3"
                                            sizing="sm"
                                            type="autocomplete"
                                            optionsMode="aql"
                                            service="cids.index"
                                            optionsDisplay="search"
                                            required
                                            :validate="validate"
                                            v-model="proc.atendimento_procedimento.cid">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" title="CID">
                                                        CID
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>

                            </template>

                            <div class="card" :key="'P' + index" v-if="proc.selected">
                                <div class="card-header d-flex justify-content-between">
                                    <span>
                                        Procedimentos Empacotados
                                    </span>
                                    <span>
                                        <a href="#" @click.prevent="proc.selected = false">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </a>
                                    </span>
                                </div>
                                <div class="card-body">
                                    <table class="table table-sm mb-0">
                                        <tr v-for="(item, iex) in proc.atendimento_procedimento.empacotados" :key="iex">
                                            <td>#{{ item.id_atendimento }}</td>
                                            <td>{{ item.procedimento.search }}</td>
                                            <td class="text-right">{{ $util.formatMoeda(item.cd_valor_total) }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </template>

                        <!-- Outras Despesas -->
                        <template v-if="outras_despesas && outras_despesas.length">
                            <az-sub-title class="mt-3" title="Outras Despesas">
                                <a href="#" @click.prevent="agrupa_od = !agrupa_od" class="card-link mr-0" title="Agrupar Outras Despesas">
                                    <i class="fa-solid fa-object-group fa-fw" v-if="!agrupa_od"></i>
                                    <i class="fa-solid fa-object-ungroup fa-fw" v-else></i>
                                </a>
                                

                                <a href="#" @click.prevent="consolida_od = !consolida_od" class="ml-2 card-link" title="Consolidar/Detalhar">
                                    <i class="fas fa-list-alt" v-if="consolida_od"></i>
                                    <i class="far fa-list-alt" v-else></i>
                                </a>

                                <a href="#" @click.prevent="ordem_alfa_od = !ordem_alfa_od" class="card-link ml-2" title="Ordem Alfa">
                                    <i class="fa fa-sort-alpha-asc" aria-hidden="true" v-if="ordem_alfa_od"></i>
                                    <i class="fa fa-sort-numeric-asc" aria-hidden="true" v-else></i>
                                </a>
                            </az-sub-title>

                            <template v-if="consolida_od && 1 == 0">
                                <pre>{{ outras_despesas }}</pre>
                            </template>

                            <template v-else>
                                <div v-for="(lista_od, grupo, index) in outras_despesas_agrupada" :key="'od' + index">
                                    <az-sub-title class="mt-3" :title="grupo" v-if="grupo">
                                        <span v-if="false">
                                            {{ $util.formatMoeda(lista_od.reduce((total, despesa) => total + (despesa.dc_valor * despesa.dc_quantidade), 0)) }}
                                        </span>
                                    </az-sub-title>
                                    <div class="form-row" v-for="(despesa, index) in lista_od" :key="'od' + index">
                                        <div class="col col-12 col-md-1">
                                            <small class="form-text text-muted text-nowrap text-truncate" v-if="!index && 1 == 0">
                                                Tabela
                                            </small>
                                            <az-input
                                                :label="index ? '' : 'Tabela'"
                                                sizing="sm"
                                                type="select"
                                                optionsMode="aql"
                                                service="codigo_tabelas.index"
                                                optionsData="id_codigo_tabela"
                                                optionsDisplay="ch_codigo"
                                                v-model="despesa.id_codigo_tabela"
                                                :validate="validate" />

                                                <!-- {{ despesa.codigo_tabela ? despesa.codigo_tabela.ch_codigo : '' }} -->
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                icon="fas fa-pen"
                                                sizing="sm"
                                                :label="!index ? 'Código' : ''"
                                                placeholder="Código..."
                                                v-model="despesa.st_codigo"
                                                v-if="despesa.st_codigo !== null">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append" v-if="despesa.codigo_despesa">
                                                        <span class="input-group-text" id="basic-addon2" 
                                                            :title="'Código da despesa de ' + despesa.codigo_despesa.st_descricao">
                                                            {{ despesa.codigo_despesa.ch_codigo }}
                                                        </span>
                                                    </div>
                                                </template>
                                            </az-input>

                                            <div v-else>
                                                <small class="form-text text-muted text-nowrap text-truncate" v-if="!index">
                                                    Código
                                                </small>
                                                <div class="input-group input-group-sm">
                                                    <label class="form form-control bg-light">
                                                        {{ despesa.tabela ? despesa.tabela.codigo : '' }}
                                                    </label>
                                                    <div class="input-group-append" v-if="despesa.codigo_despesa">
                                                        <span class="input-group-text" id="basic-addon2" 
                                                            :title="'Código da despesa de ' + despesa.codigo_despesa.st_descricao">
                                                            {{ despesa.codigo_despesa.ch_codigo }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col col-12 col-md-4">
                                            <small class="form-text text-muted text-nowrap text-truncate" v-if="!index">
                                                Descrição
                                            </small>
                                            <div class="input-group input-group-sm">
                                                <label class="form form-control text-nowrap text-truncate bg-light">
                                                    <a href="#" @click.prevent="editarTabela (despesa)" v-if="despesa.tabela" class="card-link">
                                                        {{ despesa.tabela ? despesa.tabela.descricao : '' }}
                                                    </a>
                                                    <span v-else>
                                                        {{ despesa.tabela ? despesa.tabela.descricao : '' }}
                                                    </span>
                                                </label>
                                                <div class="input-group-append">
                                                    <span class="input-group-text" v-if="despesa.valor && despesa.valor.atendimento_procedimento_consumo && despesa.valor.atendimento_procedimento_consumo.dt_execucao" title="Data de Execução">
                                                        <small>
                                                            <span v-if="despesa.valor.atendimento_procedimento_consumo.dt_execucao.slice(0,10) != guia.atendimento.dt_inicio.slice(0,10)" class="mr-1">
                                                                {{ $util.getFormatDate(despesa.valor.atendimento_procedimento_consumo.dt_execucao, 'DD/MM') }}
                                                            </span> 
                                                            <span> 
                                                                {{ despesa.valor.atendimento_procedimento_consumo.dt_execucao.slice(11,16) }}
                                                                <template v-if="despesa.valor.atendimento_procedimento_consumo.hr_proc_termino">
                                                                    | {{ despesa.valor.atendimento_procedimento_consumo.hr_proc_termino }}
                                                                </template>
                                                            </span>
                                                        </small>
                                                    </span>
                                                </div>
                                                <div class="input-group-append" v-if="!viewonly && guia.pode_editar && !consolida_od">
                                                    <refresh-preco
                                                        :consumo="despesa"
                                                        :id_guia="guia.id_guia"
                                                        @refresh="refresh (true, guia.id_guia)" />

                                                    <button class="btn btn-outline-secondary" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        <i class="fas fa-ellipsis-v"></i>
                                                    </button>
                                                    <div class="dropdown-menu">
                                                        <a class="dropdown-item" href="#" @click.prevent="editar_codigo_despesa(despesa)">Editar Código do Item</a>
                                                        <a class="dropdown-item" href="#" @click.prevent="remover_despesa(despesa)">Remover Despesa</a>
                                                        <a class="dropdown-item" href="#" @click.prevent="alterar_data_execucao_despesa(despesa)">Alterar Data/Hora de Execução</a>
                                                        <template v-if="despesa.item_tabela">
                                                            <div class="dropdown-divider"></div>
                                                            <a class="dropdown-item disabled text-muted small" v-if="despesa.item_tabela">
                                                                <span v-if="despesa.item_tabela.tabela_versao" class="mr-1">
                                                                    {{ despesa.item_tabela.tabela_versao.search }}
                                                                </span>
                                                                / #{{ despesa.item_tabela.id_item_tabela }}
                                                            </a>
                                                        </template>
                                                        <template v-else-if="despesa.propria">
                                                            <div class="dropdown-divider"></div>
                                                            <a class="dropdown-item disabled text-muted small" v-if="despesa.propria">
                                                                <span v-if="despesa.propria.tabela_versao" class="mr-1">
                                                                    {{ despesa.propria.tabela_versao.search }}
                                                                </span>
                                                                / #{{ despesa.propria.id_propria }}
                                                            </a>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col col-12 col-md-1">
                                            <az-input
                                                :label="index ? '' : 'Qtd'"
                                                sizing="sm"
                                                type="number"
                                                min="1"
                                                max="9999"
                                                :edicao="guia.pode_editar"
                                                v-model="despesa.dc_quantidade"
                                                :validate="validate" />
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input   
                                                v-if="guia.pode_editar && !refreshing"
                                                :label="index ? '' : 'Vl Unitário'"
                                                sizing="sm"
                                                type="money"
                                                :precision="6"
                                                :edicao="guia.pode_editar"
                                                :validate="validate"
                                                v-model="despesa.dc_valor" />

                                            <az-input
                                                v-else
                                                :label="index ? '' : 'Vl Unitário'"
                                                sizing="sm"
                                                type="text"
                                                :edicao="false"
                                                :value="$util.formatMoeda(despesa.dc_valor)" />
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <small class="form-text text-muted text-nowrap text-truncate" v-if="!index">
                                                Valor
                                            </small>
                                            <div class="input-group input-group-sm">
                                                <label class="form form-control bg-light">
                                                    {{ $util.formatMoeda(despesa.dc_valor * despesa.dc_quantidade) }}
                                                </label>
                                                <div class="input-group-append" title="Centro de Custo" v-if="guia.centros && guia.centros.length && despesa.valor && despesa.valor.atendimento_procedimento_consumo">
                                                    <span class="input-group-text">
                                                        <a href="#" @click.prevent="alterar_centro_custo(despesa.valor.atendimento_procedimento_consumo)" class="card-link">
                                                            <small>{{ ( despesa.centro_selec && despesa.centro_selec.st_sigla ) ? despesa.centro_selec.st_sigla : '?' }}</small>
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>

                        <!-- Total -->
                        <az-sub-title class="mt-3" title="Total" v-if="guia && guia.valor_total"/>
                        <div class="form-row">
                            <div class="col col-12 col-md-10">
                            </div>
                            <div class="col col-12 col-md-2">
                                <div class="input-group input-group-sm">
                                    <label class="form form-control bg-light">
                                        {{ $util.formatMoeda(guia.valor_total.total) }}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <solicitacoes-marcacao :atendimento="guia.atendimento" />

                        <!-- Pacotes -->
                        <div class="alert alert-secondary mt-3 d-flex justify-content-between" v-if="guia.js_datas && guia.js_datas.datas && guia.js_datas.datas.length">
                            <div>
                                <i class="fa-regular fa-calendar-star mr-2 text-secondary" title="Datas definidas para guia."></i>
                                <span class="small">
                                    Datas: {{ guia.js_datas.datas.map(item => $util.getFormatDate(item)).join(', ') }}
                                </span>
                            </div>
                            <div>
                                <span class="badge badge-secondary">
                                    {{ guia.js_datas.datas.length }}
                                </span>

                                <a href="#" @click.prevent="editar_datas(guia)" class="ml-3" title="Editar datas." v-if="guia.pode_editar">
                                    <i class="fa-solid fa-pen-to-square"></i>
                                </a>
                            </div>
                        </div>

                        <div class="alert alert-secondary mt-3 d-flex justify-content-between" v-else-if="guia.atendimento && guia.atendimento.js_info && guia.atendimento.js_info.datas && guia.atendimento.js_info.datas.length">
                            <div class="small">
                                Datas: {{ guia.atendimento.js_info.datas.map(item => $util.getFormatDate(item)).join(', ') }}
                            </div>
                            <div>
                                <span class="badge badge-secondary">
                                    {{ guia.atendimento.js_info.datas.length }}
                                </span>

                                <a href="#" @click.prevent="editar_datas(guia)" class="ml-3" title="Editar datas." v-if="guia.pode_editar">
                                    <i class="fa-solid fa-pen-to-square"></i>
                                </a>
                            </div>
                        </div>

                        <div class="mt-3" v-if="lista_pacotes && lista_pacotes.length">
                            <div class="card" v-for="(atp, ipx) in lista_pacotes" :key="ipx">
                                <div class="card-header d-flex justify-content-between">
                                    <div>
                                        <a href="#" @click.prevent="atp.fl_ativo = !atp.fl_ativo" class="card-link">
                                            <i class="fas fa-layer-group mr-2"></i>
                                            {{ atp.procedimento.search }}
                                        </a>
                                    </div>
                                    <div class="text-right">
                                        {{ totalizar(atp.atendimento_pacote.atendimento_procedimentos, 'in_quantidade') }}/{{ atp.total_sessao }}

                                        <span v-if="( totalizar(atp.atendimento_pacote.atendimento_procedimentos, 'in_quantidade') < ( atp.total_sessao ) )">
                                            <button type="button" class="btn btn-link my-0 py-0" data-toggle="tooltip" data-placement="top" 
                                                :title="atp.atendimento_pacote.fl_encerrado ? 'Clique para reabrir' : 'Clique para encerrar'"
                                                @click="toggle_abertura_pacote(atp.atendimento_pacote)"
                                                :disabled="$store.state.loading">
                                                <i class="fas fa-door-open fa-fw" v-if="!atp.atendimento_pacote.fl_encerrado"></i>
                                                <i class="fas fa-door-closed fa-fw" v-else></i>
                                            </button>
                                        </span>

                                        <div v-if="atp.atendimento_pacote.fl_encerrado && atp.atendimento_pacote.st_motivo" class="text-truncate text-right small text-muted" style="max-width: 300px">
                                            {{ atp.atendimento_pacote.st_motivo }}
                                        </div>
                                    </div>
                                </div>
                                <ul class="list-group" v-if="!atp.fl_ativo">
                                    <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(atp_pacote, atx) in ordenado(atp.atendimento_pacote.atendimento_procedimentos)" :key="atx">
                                        <div>
                                            #{{ atp_pacote.id_atendimento }} 
                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                            <span title="Data do Atendimento" :class="( atp_pacote.dt_execucao && atp_pacote.dt_execucao.slice(0,10) != atp_pacote.atendimento.dt_inicio.slice(0,10) ) ? 'text-muted' : ''">
                                                {{ $util.getFormatDate(atp_pacote.atendimento.dt_inicio) }}
                                            </span>

                                            <template v-if="atp_pacote.dt_execucao && atp_pacote.dt_execucao.slice(0,10) != atp_pacote.atendimento.dt_inicio.slice(0,10)">
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                <span title="Data Informada">
                                                    {{ $util.getFormatDate(atp_pacote.dt_execucao) }}
                                                </span>
                                            </template>

                                            <a href="#" @click.prevent="editar_data_sessao(atp_pacote)" class="ml-3" title="Editar data de execução.">
                                                <i class="fa-solid fa-pen-to-square"></i>
                                            </a>

                                            <span class="ml-3 text-muted" v-if="atp_pacote.atendimento && atp_pacote.atendimento.medico">
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                {{ atp_pacote.atendimento.medico.st_nome_exibicao }}
                                            </span>
                                        </div>
                                        <div>
                                            x{{ atp_pacote.in_quantidade }}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- Rastreabilidade -->
                        <table class="table table-sm table-hover small mt-3" v-if="guia && guia.rastreabilidade">
                            <thead>
                                <tr>
                                    <th>Evento</th>
                                    <th>Criador</th>
                                    <th>Responsável</th>
                                    <th>Data</th>
                                    <th>Informação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(evento, iex) in guia.rastreabilidade" :key="iex">
                                    <td>{{ evento.descricao }}</td>
                                    <td>{{ evento.criador }}</td>
                                    <td>{{ evento.usuario }}</td>
                                    <td>
                                        {{ $util.getFormatDate(evento.data) }}
                                        <span v-if="evento.data">
                                            {{ evento.data.substr(11,5) }}
                                        </span>
                                    </td>
                                    <td>{{ evento.numero }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <br><br>

                        <pre v-if="1 == 0">{{ guia }}</pre>

                    </template>

                </div>
                <div class="modal-footer d-flex justify-content-between" v-if="guia">
                    <div>
                        <template v-if="!viewonly">
                            <button type="button" class="btn btn-warning mr-2" @click="adicionarPendencia ()"
                                v-if="guia.ch_status == 'PR' || guia.ch_status == 'PE' || guia.ch_status == 'AF'">
                                <i class="fas fa-exclamation-circle mr-2"></i>
                                Pendência
                            </button>
                            <button type="button" class="btn btn-dark mr-2" v-if="guia.ch_status == 'EF'"
                                @click="retirar_da_fatura ()">
                                <i class="fas fa-upload mr-2"></i>
                                Remover da Fatura
                            </button>
                        </template>
                    </div>
                    <div v-if="!solicitarCancelamento">
                        <template v-if="!viewonly">

                            <span class="dropdown dropup mr-2" v-if="guia.atendimento && guia.atendimento.marcacao && guia.atendimento.marcacao.arquivos" title="Anexos" :hide_content_while_loading="true">
                                <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fa-solid fa-plus" v-if="!guia.atendimento.marcacao.arquivos.length && !( guia.atendimento.paciente && guia.atendimento.paciente.arquivos && guia.atendimento.paciente.arquivos.length )"></i>
                                    <i class="fa-solid fa-paperclip" v-else></i>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a href="#" @click.prevent="abrir_anexar_arquivo()" class="dropdown-item" v-if="guia.atendimento.marcacao && guia.atendimento.marcacao.arquivos"> 
                                        <i class="fa-solid fa-plus fa-fw mr-2" v-if="!guia.atendimento.marcacao.arquivos.length"></i>
                                        <i class="fa-solid fa-paperclip fa-fw mr-2" v-else></i>
                                        Atendimento
                                    </a>

                                    <a href="#" @click.prevent="abrir_anexar_arquivo(true)" class="dropdown-item" v-if="guia.atendimento && guia.atendimento.paciente && guia.atendimento.paciente.arquivos"> 
                                        <i class="fa-solid fa-plus fa-fw mr-2" v-if="!guia.atendimento.paciente.arquivos.length"></i>
                                        <i class="fa-solid fa-paperclip fa-fw mr-2" v-else></i>
                                        Paciente
                                    </a>
                                </div>
                            </span>

                            <az-submit color="outline-primary mr-2" v-if="false && guia.atendimento && guia.atendimento.marcacao && guia.atendimento.marcacao.arquivos" @click="abrir_anexar_arquivo()" title="Anexos" :hide_content_while_loading="true">
                                <i class="fas fa-paperclip" v-if="guia.atendimento.marcacao.arquivos.length"></i>
                                <i class="fa fa-plus" aria-hidden="true" v-else></i>
                            </az-submit>

                            <button class="btn btn-outline-danger mr-2" v-if="guia.id_guia && guia.ch_status == 'AF'" @click="solicitarCancelamento = true">
                                Solicitar Cancelamento
                            </button>
                        </template>
                        <button class="btn btn-outline-secondary mr-2" v-if="guia.id_guia" @click="imprimir()">
                            Imprimir
                        </button>
                        <button class="btn btn-outline-secondary mr-2" @click="$util.logAudit('guia', guia.id_guia)"
                            v-if="guia.id_guia">
                            Log
                        </button>
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="!viewonly && guia.id_guia && verificar_status(['EF', 'AF', 'GT', 'GP', 'DI', 'PT', 'PR', 'PE', 'TS', 'PF', 'FT'], guia.ch_status) && ( guia.pode_editar || guia.ch_status != 'FT' )" @click="atualizar()">Atualizar</az-submit>
                    </div>
                    <div v-else-if="!viewonly" class="flex-grow-1">
                        <az-input
                            placeholder="Motivo de Cancelamento..."
                            :mb="false"
                            required
                            v-model="motivoCancelamento">

                            <template v-slot:button-pos>
                                <div class="input-group-prepend">
                                    <button class="btn btn-success btn-sm ml-1" type="button" @click="confirmarSolicitarCancelamento ()">
                                        <i class="fa fa-check" aria-hidden="true"></i>
                                    </button>
                                    <button class="btn btn-danger btn-sm ml-1" type="button" @click="solicitarCancelamento = false">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>

                        </az-input>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <guia-motivo-glosa
        ref="motivoglosaguia"
        :status=" ( guia && guia.ch_status == 'PR' ) ? 'PR' : 'PE' "
        @refresh="refresh ()"
        modalPrefix="guia" />

    <cadastro-item-tabela
        :guiaedicao="true"
        ref="cadtab" />

    <alterar-procedimento ref="alterarproc" @refresh="refresh()" />
    <alterar-profissional ref="alterarprof" @refresh="refresh()" />

    <div v-if="guia && marcacao && guias && guias.length">

        <Visualizacao
            :marcacao="marcacao"
            :guias="guias"
            :logo_url="logo_url"
            :nome_contratado_ass="nome_contratado_ass"
            ref="vis" />

        <div id="print" v-show="false">
            <div v-if="guia.nome == 'Consulta'">
                <guia-de-consulta indice="0" :guias="[guia]"></guia-de-consulta>
            </div>
            <div v-if="guia.nome == 'SP/SADT'">
                <guia-s-p-s-a-d-t indice="0" :guias="[guia]"></guia-s-p-s-a-d-t>
            </div>
        </div>
    </div>


    <!-- Grau de Participação -->
    <div class="modal fade" id="grauParticModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content" v-if="edicao_grau">
                <div class="modal-header">
                    <h5 class="modal-title">Alterar Grau de Participação</h5>
                    <button type="button" class="close" @click="fechar('grauParticModal')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="alert alert-info">{{ edicao_grau.item_tabela ? edicao_grau.item_tabela.st_nome : '' }}</p>

                    <az-input
                        label="Grau de Participação"
                        type="select"
                        optionsMode="aql"
                        service="grau_participacoes.index"
                        optionsData="id_grau_participacao"
                        optionsDisplay="search"
                        v-model="edicao_grau.id_grau_participacao"
                        :validate="validate" />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar('grauParticModal')">Fechar</button>
                    <button type="button" class="btn btn-success" @click="atualizar_grau_partic()">Alterar</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal Edição de Data -->
    <div class="modal fade" id="edicaoDataPacoteGuiaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content" v-if="edicao_data">
                <div class="modal-header">
                    <h5 class="modal-title">Editar Data de Execução (Guia)</h5>
                    <button type="button" class="close" aria-label="Close" @click="fechar('edicaoDataPacoteGuiaModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <az-input
                        label="Data de Execução"
                        type="date"
                        v-model="edicao_data.dt_execucao"
                        required
                        :validate="validate" />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar('edicaoDataPacoteGuiaModal')">Cancelar</button>
                    <az-submit @click="salvar_data_sessao()">Atualizar</az-submit>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal Motivo Encerramento -->
    <div class="modal fade" id="motivoEncerraPacoteGuiaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content" v-if="pacote_selecionado">
                <div class="modal-header">
                    <h5 class="modal-title">Motivo</h5>
                    <button type="button" class="close" @click="fechar('motivoEncerraPacoteGuiaModal')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <az-input   
                        label="Motivo"
                        type="textarea"
                        required
                        :validate="validate"
                        v-model="motivo_fecha_pacote" />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar('motivoEncerraPacoteGuiaModal')">Cancelar</button>
                    <button type="button" class="btn btn-success" @click="toggle_abertura_pacote(pacote_selecionado, motivo_fecha_pacote)">Encerrar</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Alterar Data de Execução -->
    <div class="modal fade" id="alterarDataExecucaoDespesaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable" role="document">
            <div class="modal-content" v-if="edicao_data_despesa">
                <div class="modal-header">
                    <h5 class="modal-title">Alterar Data de Execução</h5>
                    <button type="button" class="close" @click="fechar('alterarDataExecucaoDespesaModal')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <az-input   
                        v-if="edicao_data_despesa.edicao"
                        type="datetime-local"
                        label="Data/Hora de Execução"
                        :step="60"
                        v-model="edicao_data_despesa.edicao.dt_execucao"
                    />

                    <az-input   
                        v-if="edicao_data_despesa.edicao"
                        type="time"
                        label="Hora Final"
                        v-model="edicao_data_despesa.edicao.hr_proc_termino"
                    />

                    <pre v-else>{{ edicao_data_despesa }}</pre>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar('alterarDataExecucaoDespesaModal')">Cancelar</button>
                    <az-submit @click="atualizar_data_execucao_despesa()">Atualizar</az-submit>
                </div>
            </div>
        </div>
    </div>

    <!-- Envio de Arquivo -->
    <template v-if="acao_anexar && guia && guia.atendimento && guia.atendimento.marcacao && guia.atendimento.marcacao.arquivos">
        <az-file-upload
            ref="upload"
            :viewonly="!guia.pode_editar"
            @refresh="carregar_arquivos(false, anexar_pacientes)"
            :multiple="true"
            :arquivos="anexar_pacientes ? guia.atendimento.paciente.arquivos : guia.atendimento.marcacao.arquivos"
            :parms="{ 
                model_type: anexar_pacientes ? 'pessoa' : 'marcacao', 
                model_id: anexar_pacientes ? guia.atendimento.id_paciente : guia.atendimento.marcacao.id_marcacao, 
                id_paciente: guia.atendimento.id_paciente,
            }" />
    </template>   

    <empacotados ref="empac" />

    <editar-datas-marcacao ref="editar_datas" @refresh="refresh()" @lancar="gerar_outras_datas" />

    <alterar-centro-custo ref="alterar_centro_custo" @refresh="refresh()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import GuiaMotivoGlosa from '../../tiss/GuiaMotivoGlosa.vue';
import CadastroItemTabela from '../../cadastros/shared/CadastroItemTabela.vue';
import GuiaDeConsulta from '../../tiss/GuiaDeConsulta.vue';
import GuiaSPSADT from '../../tiss/GuiaSPSADT.vue';
import RefreshPreco from '../../shared/RefreshPreco.vue';
import Visualizacao from "../../tiss/VisualizacaoGuia.vue";
import AlterarProcedimento from '../recepcao/AlterarProcedimento.vue';
import AlterarProfissional from '../recepcao/AlterarProfissional.vue';
import ServicoOperadora from '../../shared/ServicoOperadora.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import Empacotados from './Empacotados.vue';
import SolicitacoesMarcacao from '../suprimentos/SolicitacoesMarcacao.vue';
import EditarDatasMarcacao from '../../../components/tiss/EditarDatasMarcacao.vue';
import VerAutorizacao from '../autoriz/VerAutorizacao.vue';
import MedicoSolicitante from '../../shared/MedicoSolicitante.vue';
import AlterarCentroCusto from '../recepcao/AlterarCentroCusto.vue';

export default {
    data() {
        return {
            guia: null,
            motivoGlosaRef: null,
            senha: null,
            validate: false,
            edicaoSolicitante: false,
            trocaDeSolicitante: false,
            solicitarCancelamento: false,
            motivoCancelamento: "",
            marcacao: null,
            guias: [],
            logo_url: "",
            refreshing: false,
            nome_contratado_ass: false,
            edicao_grau: null,
            alterado_grau: null,
            consolida_od: false, 
            agrupa_od: false, 
            ordem_alfa_od: false, 
            ordem_alfa_proc: false, 
            acao_anexar: false, 
            mudanca_plano: false, 
            mudanca_contrato: false, 
            edicao_data: null, 
            pacote_selecionado: null, 
            motivo_fecha_pacote: "", 
            anexar_pacientes: false, 
            centro_selec: "", 
            edicao_data_despesa: null, 
        }
    },

    components: {
        AzInput,
        AzSubTitle,
        GuiaMotivoGlosa,
        AzSubmit,
        CadastroItemTabela,
        GuiaDeConsulta,
        GuiaSPSADT,
        RefreshPreco,
        Visualizacao,
        AzEmptyState,
        AlterarProcedimento,
        AlterarProfissional,
        ServicoOperadora,
        AzFileUpload, 
        Empacotados,
        SolicitacoesMarcacao, 
        EditarDatasMarcacao, 
        VerAutorizacao, 
        MedicoSolicitante,
        AlterarCentroCusto, 
    },

    props: ['motivoglosa', 'viewonly', 'pode_ver_conta'],

    computed: {
        lista_procedimentos: function () {
            if ( !this.guia || !this.guia.atendimento_procedimento_guias ) 
                return [];

            let lista = this.guia.atendimento_procedimento_guias;

            if ( this.centro_selec ) { 
                lista = lista.filter(item => _.get(item, 'atendimento_procedimento.centro_selec.id_centro_custo') && ( _.get(item, 'atendimento_procedimento.centro_selec.id_centro_custo') == this.centro_selec ));
            }

            if ( this.ordem_alfa_proc ) { 
                return _.orderBy(lista, item => { 
                    if ( this.guia.plano.operadora.fl_sus ) { 
                        return item.atendimento_procedimento.procedimento.st_procedimento;
                    } else { 
                        return item.item_tabela ? item.item_tabela.st_nome : '';
                    }
                });
            } else { 
                return lista;
            }
        },

        outras_despesas: function () {
            if ( !this.guia )
                return [];

            let lista = _.flatten(
                this.guia.atendimento_procedimento_guias
                .map(item => {
                    return item.consumo_procedimentos.filter(item => !this.centro_selec || ( _.get(item, 'centro_selec.id_centro_custo') == this.centro_selec ));
                })
            );

            if ( this.consolida_od ) { 
                lista = _.map(
                    _.groupBy(lista, 'tabela.descricao'),
                    items => { 
                        let base = _.cloneDeep(_.first(items));
                        base.dc_quantidade = _.sumBy(items, 'dc_quantidade');
                        return base;
                    });
            }

            if ( this.ordem_alfa_od ) { 
                lista = _.orderBy(lista, 'tabela.descricao');
            }

            return lista;
        },

        outras_despesas_agrupada: function () { 
            return _.groupBy(
                _.orderBy(this.outras_despesas, od => this.agrupa_od ? od.item.tipo : ''), 
                od => this.agrupa_od ? od.item.tipo : ''
            );
        },

        lista_pacotes: function () { 

            if ( !this.guia )
                return [];

            return this.guia.atendimento_procedimento_guias.flatMap(apg => { 
                if ( apg.atendimento_procedimento && apg.atendimento_procedimento.total_sessao && apg.atendimento_procedimento.atendimento_pacote ) { 
                    return [
                        apg.atendimento_procedimento
                    ];
                }

                return [];
            });

        }
    },

    methods: {
        toggle_cid_proc (proc) { 
            if ( proc.atendimento_procedimento ) { 
                if ( !proc.atendimento_procedimento.id_cid && !proc.atendimento_procedimento.cid ) { 
                    proc.atendimento_procedimento.id_cid = ""; 
                    proc.atendimento_procedimento.cid = ""; 
                }

                proc.info_cid = !proc.info_cid;
            }

            this.$forceUpdate();
        },

        atualizar_data_execucao_despesa () { 
            console.log('edicao_data_despesa', this.edicao_data_despesa);

            this.$util.atualizar(this, { 
                service: 'guias', 
                func: 'alterar_data_execucao_despesa', 
                dados: { 
                    id_atendimento_procedimento_consumo: this.edicao_data_despesa.origem.id_atendimento_procedimento_consumo, 
                    dt_execucao: this.edicao_data_despesa.edicao.dt_execucao, 
                    hr_proc_termino: this.edicao_data_despesa.edicao.hr_proc_termino, 
                },
                toast: true,
                modal: 'alterarDataExecucaoDespesaModal',
                callback: () => {
                    this.edicao_data_despesa.origem.dt_execucao = this.edicao_data_despesa.edicao.dt_execucao;
                    this.edicao_data_despesa.origem.hr_proc_termino = this.edicao_data_despesa.edicao.hr_proc_termino;
                    this.edicao_data_despesa = null;
                }
            });
        },

        alterar_data_execucao_despesa (item) { 
            this.edicao_data_despesa = { 
                edicao: _.cloneDeep(item.valor.atendimento_procedimento_consumo),
                origem: item.valor.atendimento_procedimento_consumo,
            };

            $('#alterarDataExecucaoDespesaModal').modal('show');
        },

        alterar_centro_custo(item) { 
            this.$refs.alterar_centro_custo.abrir(item);
        },

        imprimir_espelho_guia (guia) { 
            this.$util.print_preview('imprimir/espelho_guia/' + guia.id_guia, true, { noass: 1 }, true);  
        }, 

        preencher_periodo_da_internacao(guia) { 
            guia.dt_inicio_fat = guia.intern.dt_admissao.slice(0,10) + ' ' + guia.intern.st_hora_admissao;

            if ( guia.intern.dt_alta ) { 
                guia.dt_fim_fat = guia.intern.dt_alta.slice(0,10) + ' ' + guia.intern.st_hora_alta;
            }
        },

        ver_conta (internacao) { 
            this.$emit('conta', internacao.id_internacao);
        },

        salvar_obs_pend (pend) { 
            this.$util.atualizar(this, { 
                service: 'guia_motivo_glosas', 
                func: 'store', 
                dados: { 
                    id_guia_motivo_glosa: pend.id_guia_motivo_glosa, 
                    st_obs_sol: pend.edit_obs,
                },
                toast: true,
                callback: () => {
                    pend.st_obs_sol = pend.edit_obs;
                    pend.edit_obs = null;
                }
            });
        },

        editar_obs (pend) { 
            if ( pend.edit_obs === null || pend.edit_obs === undefined ) { 
                pend.edit_obs = "";     
            } else { 
                pend.edit_obs = null;
            }

            this.$forceUpdate(); 
        }, 

        ordenado(lista) { 
            return _.orderBy(lista, atp => atp.dt_execucao ? atp.dt_execucao : ( atp.atendimento ? atp.atendimento.dt_inicio : '' ), 'asc');
        },
        
        toggle_abertura_pacote(pacote, motivo = null) {
            this.pacote_selecionado = pacote; // _.cloneDeep(pacote); 

            if ( pacote && !pacote.fl_encerrado && !motivo ) { 
                
                this.motivo_fecha_pacote = this.pacote_selecionado.st_motivo;
                this.validate = false;

                $('#motivoEncerraPacoteGuiaModal').modal('show');

                return;

            }

            this.$util.atualizar(this, { 
                service: 'atendimento_pacotes',
                func: 'toggle_pacote_encerrar',
                dados: { 
                    id_atendimento_pacote: pacote.id_atendimento_pacote, 
                    motivo: motivo,  
                },
                callback: ap => { 
                    console.log('ap', ap);
                    console.log('pacote', pacote);

                    if ( ap && ap.id_atendimento_pacote ) { 
                        pacote.fl_encerrado = ap.fl_encerrado;
                        pacote.st_motivo = ap.st_motivo;
                    } else { 
                        this.refresh();
                    }
                },
                modal: 'motivoEncerraPacoteGuiaModal', 
            });
        },

        editar_data_sessao (atp) { 
            this.edicao_data = _.cloneDeep(atp);

            if ( !this.edicao_data.dt_execucao ) { 
                this.edicao_data.dt_execucao = this.edicao_data.atendimento.dt_inicio.slice(0,10);
            }

            this.edicao_data.ref = atp; 

            $('#edicaoDataPacoteGuiaModal').modal('show');
        },

        salvar_data_sessao () { 

            this.$util.atualizar (this, { 
                service: 'guias', 
                func: 'alterar_data_sessao', 
                dados: { 
                    id_atendimento_procedimento: this.edicao_data.id_atendimento_procedimento, 
                    dt_execucao: this.edicao_data.dt_execucao,
                },
                toast: true,
                modal: 'edicaoDataPacoteGuiaModal',
                callback: () => {
                    this.edicao_data.ref.dt_execucao = this.edicao_data.dt_execucao;
                }
            });

        },

        editar_datas (guia) { 
            if ( guia.js_datas ) { 
                this.$refs.editar_datas.abrir(guia, guia);    
            } else { 
                this.$refs.editar_datas.abrir(guia);
            }
        },
        
        gerar_outras_datas (datas) { 
            this.$util.atualizar(this, { 
                service: 'atendimentos', 
                func: 'set_guia_datas', 
                dados: { 
                    id_atendimento: this.guia.id_atendimento, 
                    id_guia: this.guia.id_guia,
                    datas: datas, 
                },
                toast: true,
                callback: () => {
                    this.refresh_datas();
                }
            });
        },

        totalizar (lista, campo, func = null) { 
            if ( func ) { 
                return lista.reduce((acc, item) => { 
                        return acc + func(item);
                    }, 0);
            }

            return lista.reduce((acc, item) => { 
                    return acc + parseFloat(item[campo] ? item[campo] : 0);
                }, 0);
        },
    
        editar_codigo_despesa (despesa) { 
            despesa.st_codigo = ( despesa.tabela ? despesa.tabela.codigo : '' );
        },

        editar_codigo_item (proc) { 
            proc.st_codigo = this.guia.plano.operadora.fl_sus
                ? proc.atendimento_procedimento.procedimento.st_codigo_sus
                : ( proc.item_tabela ? proc.item_tabela.st_codigo : '' );
        },

        abrirAtendimento (id_atendimento) { 
            $('.modal').modal('hide');
            
            this.$nextTick(() => { 
                this.$util.abrir_atendimento(this, id_atendimento);
            });
        },

        alterar_data_execucao (proc) { 
            proc.alter_data = true;
            this.$forceUpdate();
        },

        ver_empacotados (proc) { 
            this.$refs.empac.abrir(proc.id_atendimento_procedimento);
            // proc.selected = !proc.selected;
        },

        exibir_composicao_valor(item, operadora, id_reducao = null) {
            /*
            const contexto = {
                data: this.dados.atendimento.dt_inicio,
                cirurgia: this.is_cirurgia,
                emergencia: this.dados.recepcao ? this.dados.recepcao.fl_emergencia : false,
            };
            */

            this.$refs.cadtab.exibir_moeda_corrente(item, operadora, id_reducao);
        },

        alterar_grau_partic (proc) {
            this.alterado_grau = proc;
            this.edicao_grau = _.cloneDeep(proc);
            $('#grauParticModal').modal('show');
        },

        atualizar_grau_partic () {
            const grau = this.$store.state.options['grau_participacoes.index'].find(item => item.id_grau_participacao == this.edicao_grau.id_grau_participacao);

            if ( grau ) {
                this.alterado_grau.grau_participacao = grau;
                this.alterado_grau.id_grau_participacao = this.edicao_grau.id_grau_participacao;
            }

            $('#grauParticModal').modal('hide');
        },

        fechar (modal) {
            $('#' + modal).modal('hide');
        },

        cadastro_paciente(paciente) {
            $('.modal').modal('hide');
            this.$root.perfil(paciente);
        },

        elegibilidade(value) {
            console.log('refresh elegibilidade: ' + value);
            this.refresh();
        },

        verificar_status(lista, status) {
            return lista.includes(status);
        },

        alterar_profissional () {
            this.$refs.alterarprof.alterar_guia(this.guia);
        },

        alterar_procedimento (item) {
            this.$refs.alterarproc.abrir(item, this.guia);
        },

        remover_procedimento (item) {
            let motivo = prompt('Informe o motivo da remoção do procedimento');

            if ( !motivo )
                return;

            /*
            if ( !confirm('Confirmar remover o procedimento da guia?') )
                return;
            */

            this.$util.atualizar(this, {
                service: 'guias',
                func: 'remover_procedimento',
                dados: {
                    id_atendimento_procedimento_guia: item.id_atendimento_procedimento_guia,
                    motivo: motivo, 
                },
                toast: true,
                callback: () => {
                    this.refresh();
                }
            });
        },

        remover_despesa (item) {
            if ( !confirm('Confirmar remover a despesa da guia?') )
                return;

            this.$util.atualizar(this, {
                service: 'guias',
                func: 'remover_despesa',
                dados: {
                    id_consumo_procedimento_guia: item.id_consumo_procedimento_guia,
                },
                toast: true,
                callback: () => {
                    this.refresh();
                }
            });
        },

        recalc_contrato () {
            this.$util.atualizar(this, {
                service: 'guias',
                func: 'recalc_contrato',
                dados: {
                    id_guia: this.guia.id_guia,
                },
                callback: () => {
                    this.refresh (true, this.guia.id_guia)
                },
                toast: true
            })
        },

        imprimir () {
            this.guias = [];
            this.$store.commit("loading", true);

            this.$util.loadItem(this, {
                    service: "marcacoes",
                    func: "show",
                    id: this.guia.id_atendimento,
                    parms: {
                        by_atendimento: true,
                        guia_edicao: true,
                    }
                })
                .then(res => {
                    this.marcacao = res;

                    let query = {
                        q: [
                        {
                            name: "operadoras.show",
                            id: "operadora",
                            parms: {
                            id: this.marcacao.plano.id_operadora,
                            with: ["logo.arquivo"]
                            }
                        }
                        ]
                    };

                    /*
                    this.marcacao.atendimento.guias.forEach((item, idx) => {
                        query.q.push({
                        name: "tiss.gerar_json",
                        id: "guia." + idx,
                        parms: {
                            id: item.id_guia
                        }
                        });
                    });
                    */

                    query.q.push({
                        name: "tiss.gerar_json",
                        id: "guia",
                        parms: {
                            id: this.guia.id_guia
                        }
                    });

                    query.q.push({
                        name: "configuracoes.index",
                        id: "config_nome_ass",
                        parms: {
                            where: {
                                st_slug: 'nome-contratado-ass',
                                st_valor: '1',
                            }
                        }
                    });

                    this.axios.post("/aql", query).then(res => {

                        this.logo_url = res.data.operadora.data.logo
                            ? res.data.operadora.data.logo.arquivo.temporary_url
                            : "";

                        this.marcacao.atendimento.guias.forEach((item) => {
                            if (res.data.guia.status == 200 && this.guia.id_guia == item.id_guia) {
                                this.guias.push(res.data.guia.data);
                            }

                            // Depois das mudanças no componente de visualização de guias, esse codigo causa erro
                            // else {
                            //     this.guias.push(null);
                            // }
                        });

                        this.nome_contratado_ass = res.data.config_nome_ass.data && res.data.config_nome_ass.data.length;

                        this.$nextTick(() => {
                            this.$refs.vis.inicializacao();
                        });

                    })
                    .finally(() => {
                        this.$store.commit("loading", false);
                    });

                })
                .catch(() => {
                    this.$store.commit("loading", false);
                });

        },
        atualizarItemTabela (proc) {

            $('[data-toggle="tooltip"]').tooltip('dispose');

            this.$util.atualizar (this, {
                service: 'atendimentos',
                func: 'precificar',
                dados: proc,
                callback: () => { this.refresh (true, this.guia.id_guia) },
                toast: true,
            });

        },

        setNomeMedico () {
            if ( this.guia.atendimento.medico_solicitante ) {
                this.trocaDeSolicitante = false;
            }
        },

        trocarSolicitante () {
            this.trocaDeSolicitante = true;
            this.guia.atendimento.medico_solicitante = null;
        },

        editarTabela (item) {
            $('#editarGuiaModal').modal('hide');
            this.$refs.cadtab.abrirItemTabela (
                item.id_item_tabela ? item.id_item_tabela : item.id_propria,
                this.reabrir,
                item.tabela
            );
        },

        reabrir () {
            this.abrir(this.guia);
        },

        abrir (guia) {
            this.centro_selec = ""; 
            this.mudanca_plano = false;
            this.mudanca_contrato = false;
            this.consolida_od = false;
            this.ordem_alfa_proc = false;
            this.ordem_alfa_od = false;
            this.edicaoSolicitante = false;
            this.trocaDeSolicitante = false;
            this.solicitarCancelamento = false;
            this.motivoCancelamento = "";
            this.validate = false;
            this.guia = null;
            this.refresh (false, guia.id_guia);
        },

        retirar_da_fatura () {
            if ( !confirm('Confirmar remover essa guia da fatura?') )
                return;

            this.$util.atualizar(this, {
                service: 'guias',
                func: 'retirar',
                dados: {
                    guias: [this.guia],
                },
                callback: () => {
                    this.refresh (true, this.guia.id_guia);
                }
            });
        },

        adicionarPendencia () {
            this.$refs.motivoglosaguia.abrir([this.guia]);
        },

        refresh_datas () { 

            console.log('refresh_datas');

            this.$util.loadItem(this, {
                service: 'guias',
                id: this.guia.id_guia,
                parms: {
                    paralista: true,
                    edicao: true,
                }
            })
            .then(res => {

                if ( res.js_datas && res.js_datas.datas ) { 
                    this.guia.js_datas.datas = res.js_datas.datas;
                }

                if ( res.atendimento && res.atendimento.js_info && res.atendimento.js_info.datas ) { 
                    this.guia.atendimento.js_info.datas = res.atendimento.js_info.datas;
                }
            });

        },

        refresh (emit = true, id_guia = null) {

            this.$store.commit('loading', true);

            if ( !emit && id_guia )
                $('#editarGuiaModal').modal('show');

            /*
            if ( !id_guia && this.guia )
                id_guia = this.guia.id_guia;

            this.guia = null;
            */

            this.$nextTick(() => {

                this.$util.loadItem(this, {
                    service: 'guias',
                    id: id_guia ? id_guia : this.guia.id_guia,
                    parms: {
                        paralista: true,
                        edicao: true,
                    }
                })
                .then(res => {
                    this.refreshing = true;

                    if ( res && res.atendimento && res.atendimento.js_info && JSON.stringify(res.atendimento.js_info) == '[]' ) { 
                        res.atendimento.js_info = {};
                    }

                    this.$nextTick(() => {
                        this.guia = { ...res };
                        this.refreshing = false;
                    });

                    if ( emit )
                        this.$emit('refresh');
                    else if ( id_guia )
                        $('#editarGuiaModal').modal('show');
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });

            });
        },

        solucionarPendencia (pend) {
            if ( this.viewonly ) { 
                this.$toast.add({ 
                    severity: 'info', 
                    summary: 'Atenção', 
                    detail: 'Acesso somente para visualização.', 
                    life: 5000 
                });
                return;
            }

            $('[data-toggle="tooltip"]').tooltip('dispose');

            this.$util.toggle(this, {
                service: 'guia_motivo_glosas',
                dados: {
                    id_guia_motivo_glosa: pend.id_guia_motivo_glosa,
                    fl_ativo: false,
                },
                callback: () => {
                    this.refresh (true);
                },
            });
        },

        confirmarSolicitarCancelamento () {
            this.$util.atualizar (this, {
                service: 'guias',
                func: 'solicitar_cancelamento',
                dados: {
                    id_guia: this.guia.id_guia,
                    motivo: this.motivoCancelamento,
                },
                modal: 'editarGuiaModal',
                callback: () => {
                    this.$emit('refresh');
                }
            });
        },

        atualizar () {
            this.$util.atualizar (this, {
                service: 'guias',
                dados: this.guia,
                modal: 'editarGuiaModal',
                callback: () => {
                    this.$emit('refresh');
                }
            });
        },

        // Arquivos
        abrir_anexar_arquivo(paciente = false) { 
            this.acao_anexar = true;
            this.anexar_pacientes = paciente;

            if ( paciente ) { 

                if ( this.guia.atendimento.paciente  
                    && this.guia.atendimento.paciente.arquivos
                    && this.guia.atendimento.paciente.arquivos.length 
                    && !this.guia.atendimento.paciente.arquivos.find(arq => arq.arquivo) ) { 

                    this.carregar_arquivos(true, paciente);
                    return;

                }

            } else { 
            
                if (  this.guia.atendimento.marcacao.arquivos.length 
                    && !this.guia.atendimento.marcacao.arquivos.find(arq => arq.arquivo) ) { 

                    this.carregar_arquivos(true);
                    return;

                }

            }

            this.$nextTick(() => { 
                this.$refs.upload.abrir();
            });
        },

        carregar_arquivos (abrir = false, paciente = false) { 

            this.$store.commit('loading', true);

            this.$util.loadItem(this, { 
                service: 'arquivos',
                func: 'links',
                parms: { 
                    id: paciente ? this.guia.atendimento.id_paciente : this.guia.atendimento.marcacao.id_marcacao,
                    type: paciente ? 'pessoa' : 'marcacao',
                }
            })
            .then(res => { 

                if ( paciente ) { 
                    this.guia.atendimento.paciente.arquivos = res;
                } else {
                    this.guia.atendimento.marcacao.arquivos = res;
                }

                if ( abrir ) { 
                    this.$nextTick(() => { 
                        this.$refs.upload.abrir();
                    });
                }
                
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });

        },
    },

    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    }
}
</script>

<style scoped>
.modal-dialog2 {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}

.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>
